<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-09-12',
        major: [],
        excepts: [],
        items: [

          // [NOTE] パウダーピンク特別コーデ
          // ================================================================================

          item({
            collection  : 'PowderPinkSp',
            id          : 'GO-016',
            rare        : 'SR',
            name        : 'プリンセスブーケピンクドレス',
            imgUrl      : '/images/items/GO-016.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PowderPinkSp',
            id          : 'GO-017',
            rare        : 'SR',
            name        : 'プリンセスブーケピンクシューズ',
            imgUrl      : '/images/items/GO-017.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PowderPinkSp',
            id          : 'GO-018',
            rare        : 'SR',
            name        : 'リンセスブーケピンクヘアアクセ',
            imgUrl      : '/images/items/GO-018.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'PowderPinkSp',
            id          : 'GO-045',
            rare        : 'SR',
            name        : 'プリたまGOパウダーピンク',
            imgUrl      : '/images/items/GO-045.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'LP',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ミントブルー特別コーデ
          // ================================================================================

          item({
            collection  : 'MintBlueSp',
            id          : 'GO-019',
            rare        : 'SR',
            name        : 'プリンセスブーケブルードレス',
            imgUrl      : '/images/items/GO-019.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : 'LP',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MintBlueSp',
            id          : 'GO-020',
            rare        : 'SR',
            name        : 'プリンセスブーケブルーシューズ',
            imgUrl      : '/images/items/GO-020.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MintBlueSp',
            id          : 'GO-021',
            rare        : 'SR',
            name        : 'プリンセスブーケブルーヘアアクセ',
            imgUrl      : '/images/items/GO-021.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'LP',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MintBlueSp',
            id          : 'GO-046',
            rare        : 'SR',
            name        : 'プリたまGOミントブルー',
            imgUrl      : '/images/items/GO-046.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'LP',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ミスティパープル特別コーデ
          // ================================================================================

          item({
            collection  : 'MistyPurpleSp',
            id          : 'GO-022',
            rare        : 'SR',
            name        : 'プリンセスブーケパープルドレス',
            imgUrl      : '/images/items/GO-022.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MistyPurpleSp',
            id          : 'GO-023',
            rare        : 'SR',
            name        : 'プリンセスブーケパープルシューズ',
            imgUrl      : '/images/items/GO-023.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MistyPurpleSp',
            id          : 'GO-024',
            rare        : 'SR',
            name        : 'プリンセスブーケパープルヘアアクセ',
            imgUrl      : '/images/items/GO-024.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'MistyPurpleSp',
            id          : 'GO-047',
            rare        : 'SR',
            name        : 'プリたまGOミスティパープル',
            imgUrl      : '/images/items/GO-047.png',
            kind        : 'パシャッとアイテム',
            color       : '紫',
            brand       : 'LP',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 共通特別コーデ
          // ================================================================================

          item({
            collection  : 'CommonSp',
            id          : 'GO-004',
            rare        : 'SR',
            name        : 'プリンセスブーケグリーンドレス',
            imgUrl      : '/images/items/GO-004.png',
            kind        : '',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            id          : 'GO-005',
            rare        : 'SR',
              name        : 'プリンセスブーケグリーンシューズ',
            imgUrl      : '/images/items/GO-005.png',
            kind        : '',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',

            id          : 'GO-006',
            rare        : 'SR',
            name        : 'プリンセスブーケグリーンヘアアクセ',
            imgUrl      : '/images/items/GO-006.png',
            kind        : '',
            color       : '緑',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            rare        : 'SR',
          }),


          item({
            collection  : 'CommonSp',
            id          : 'GO-007',
            rare        : 'SR',
            name        : 'プリンセスブーケレッドドレス',
            imgUrl      : '/images/items/GO-007.png',
            kind        : '',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            id          : 'GO-008',
            rare        : 'SR',
            name        : 'プリンセスブーケレッドシューズ',
            imgUrl      : '/images/items/GO-008.png',
            kind        : '',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            id          : 'GO-009',
            rare        : 'SR',
            name        : 'プリンセスブーケレッドヘアアクセ',
            imgUrl      : '/images/items/GO-009.png',
            kind        : '',
            color       : '赤',
            brand       : 'LP',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            rare        : 'SR',
          }),


          item({
            collection  : 'CommonSp',
            id          : 'GO-010',
            rare        : 'SR',
            name        : 'プリンセスブーケホワイトドレス',
            imgUrl      : '/images/items/GO-010.png',
            kind        : '',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            id          : 'GO-011',
            rare        : 'SR',
            name        : 'プリンセスブーケホワイトシューズ',
            imgUrl      : '/images/items/GO-011.png',
            kind        : '',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            id          : 'GO-012',
            rare        : 'SR',
            name        : 'プリンセスブーケホワイトヘアアクセ',
            imgUrl      : '/images/items/GO-012.png',
            kind        : '',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            rare        : 'SR',
          }),


          item({
            collection  : 'CommonSp',
            id          : 'GO-013',
            rare        : 'SR',
            name        : 'プリンセスブーケブラックドレス',
            imgUrl      : '/images/items/GO-013.png',
            kind        : '',
            color       : '黒',
            brand       : 'LP',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            id          : 'GO-014',
            rare        : 'SR',
            name        : 'プリンセスブーケブラックシューズ',
            imgUrl      : '/images/items/GO-014.png',
            kind        : '',
            color       : '黒',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            id          : 'GO-015',
            rare        : 'SR',
            name        : 'プリンセスブーケブラックヘアアクセ',
            imgUrl      : '/images/items/GO-015.png',
            kind        : '',
            color       : '黒',
            brand       : 'LP',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonSp',
            rare        : 'SR',
          }),


          // [NOTE] 共通特典
          // ================================================================================

          item({
            collection  : 'CommonBenefit',
            id          : 'GO-001',
            rare        : 'SR',
            name        : 'プリンセスブーケイエロードレス',
            imgUrl      : '/images/items/GO-001.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonBenefit',
            id          : 'GO-002',
            rare        : 'SR',
            name        : 'プリンセスブーケイエローシューズ',
            imgUrl      : '/images/items/GO-002.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonBenefit',
            id          : 'GO-003',
            rare        : 'SR',
            name        : 'プリンセスブーケイエローヘアアクセ',
            imgUrl      : '/images/items/GO-003.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'LP',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonBenefit',
            rare        : 'SR',
          }),


          // [NOTE] 共通登場コーデ
          // ================================================================================

          item({
            collection  : 'CommonRevivals',
            id          : 'GO-025',
            rare        : 'SR',
            name        : 'ヒップホップダンストップス',
            imgUrl      : '/images/items/GO-025.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-026',
            rare        : 'SR',
            name        : 'ヒップホップダンスパンツ',
            imgUrl      : '/images/items/GO-026.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-027',
            rare        : 'SR',
            name        : 'ヒップホップダンスシューズ',
            imgUrl      : '/images/items/GO-027.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-028',
            rare        : 'SR',
            name        : 'ヒップホップダンスヘアアクセ',
            imgUrl      : '/images/items/GO-028.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'CommonRevivals',
            id          : 'GO-029',
            rare        : 'SR',
            name        : 'ポッピンキャンディトップス',
            imgUrl      : '/images/items/GO-029.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-030',
            rare        : 'SR',
            name        : 'ポッピンキャンディパンツ',
            imgUrl      : '/images/items/GO-030.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-031',
            rare        : 'SR',
            name        : 'ポッピンキャンディシューズ',
            imgUrl      : '/images/items/GO-031.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-032',
            rare        : 'SR',
            name        : 'ポッピンキャンディヘアアクセ',
            imgUrl      : '/images/items/GO-032.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'CommonRevivals',
            id          : 'GO-033',
            rare        : 'SR',
            name        : 'エンジェルナースパープルトップス',
            imgUrl      : '/images/items/GO-033.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-034',
            rare        : 'SR',
            name        : 'エンジェルナースパープルスカート',
            imgUrl      : '/images/items/GO-034.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-035',
            rare        : 'SR',
            name        : 'エンジェルナースパープルシューズ',
            imgUrl      : '/images/items/GO-035.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-036',
            rare        : 'SR',
            name        : 'エンジェルナースパープルヘアアクセ',
            imgUrl      : '/images/items/GO-036.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'CommonRevivals',
            id          : 'GO-037',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴトップス',
            imgUrl      : '/images/items/GO-037.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-038',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴスカート',
            imgUrl      : '/images/items/GO-038.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-039',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴシューズ',
            imgUrl      : '/images/items/GO-039.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-040',
            rare        : 'SR',
            name        : 'ロマーノアーティストインディゴヘアアクセ',
            imgUrl      : '/images/items/GO-040.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'CommonRevivals',
            id          : 'GO-041',
            rare        : 'SR',
            name        : 'パンクキャットレッドトップス',
            imgUrl      : '/images/items/GO-041.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-042',
            rare        : 'SR',
            name        : 'パンクキャットレッドスカート',
            imgUrl      : '/images/items/GO-042.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-043',
            rare        : 'SR',
            name        : 'パンクキャットレッドシューズ',
            imgUrl      : '/images/items/GO-043.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-044',
            rare        : 'SR',
            name        : 'パンクキャットレッドヘアアクセ',
            imgUrl      : '/images/items/GO-044.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 共通登場コーデ パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'CommonRevivals',
            id          : 'GO-048',
            rare        : 'SR',
              name        : 'カラフルアンブレラ',
            imgUrl      : '/images/items/GO-048.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-049',
            rare        : 'SR',
            name        : 'ハッピーステッキ',
            imgUrl      : '/images/items/GO-049.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-050',
            rare        : 'SR',
            name        : 'レッドローズ',
            imgUrl      : '/images/items/GO-050.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'CommonRevivals',
            id          : 'GO-051',
            rare        : 'SR',
            name        : 'しろいもりのトランペット',
            imgUrl      : '/images/items/GO-051.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] JP_Jewel03
          // ================================================================================


          // [NOTE] JP_Jewel04
          // ================================================================================


          // [NOTE] JP_Jewel05
          // ================================================================================


          // [NOTE] JP_Jewel06
          // ================================================================================


          // [NOTE] JP_FCDXSet2
          // ================================================================================


          // [NOTE] JP_JewelPactBenefit
          // ================================================================================


          // [NOTE] JP_DP_SherbetPink
          // ================================================================================


          // [NOTE] JP_DP_EternalWhite
          // ================================================================================


          // [NOTE] JP_DP_JewelPink
          // ================================================================================


        ]
      }
    },

    computed: {
      itemsPowderPinkSp () {
        return _.where(this.items, { collection: 'PowderPinkSp' })
      },

      itemsMintBlueSp () {
        return _.where(this.items, { collection: 'MintBlueSp' })
      },

      itemsMistyPurpleSp () {
        return _.where(this.items, { collection: 'MistyPurpleSp' })
      },

      itemsCommonSp () {
        return _.where(this.items, { collection: 'CommonSp' })
      },

      itemsCommonBenefit () {
        return _.where(this.items, { collection: 'CommonBenefit' })
      },

      itemsCommonRevivals () {
        return _.where(this.items, { collection: 'CommonRevivals' })
      },

    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[2]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="パウダーピンク特別コーデ" color="#00c7da" :items="itemsPowderPinkSp" />
      <ItemList title="ミントブルー特別コーデ" color="#00c7da" :items="itemsMintBlueSp" />
      <ItemList title="ミスティパープル特別コーデ" color="#00c7da" :items="itemsMistyPurpleSp" />
    </template>

    <template #col2>
      <ItemList title="共通特別コーデ" color="#00c7da" :items="itemsCommonSp" />
      <ItemList title="共通特典" color="#00c7da" :items="itemsCommonBenefit" />
    </template>

    <template #col3>
      <ItemList title="共通登場コーデ" color="#00c7da" :items="itemsCommonRevivals" />
    </template>

    <template #col4>
      <Status :date="date" :items="items" />
    </template>

    <template #col5>
    </template>

    <template #col6>
    </template>

    <template #col7>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
    .Page ::v-deep .Page__body {
      padding-bottom: $size-unit * 20;
    }
  }
</style>
